var map = {
	"./cake.webp": 1966,
	"./crown-blue.webp": 1967,
	"./crown.webp": 1968,
	"./pocket.webp": 1969,
	"./present.webp": 1970,
	"./relegation.webp": 1971,
	"./t-deposit.webp": 1972,
	"./t-turnover.webp": 1973,
	"./vip-bg.webp": 1974,
	"./vip1.gif": 1975,
	"./vip1.webp": 1976,
	"./vip10-bg.webp": 1977,
	"./vip10.gif": 1978,
	"./vip10.webp": 1979,
	"./vip11-bg.webp": 1980,
	"./vip11.gif": 1981,
	"./vip11.webp": 1982,
	"./vip12-bg.webp": 1983,
	"./vip12.gif": 1984,
	"./vip12.webp": 1985,
	"./vip2.gif": 1986,
	"./vip2.webp": 1987,
	"./vip3.gif": 1988,
	"./vip3.webp": 1989,
	"./vip4.gif": 1990,
	"./vip4.webp": 1991,
	"./vip5.gif": 1992,
	"./vip5.webp": 1993,
	"./vip6.gif": 1994,
	"./vip6.webp": 1995,
	"./vip7.gif": 1996,
	"./vip7.webp": 1997,
	"./vip8.gif": 1998,
	"./vip8.webp": 1999,
	"./vip9.gif": 2000,
	"./vip9.webp": 2001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 469;